// REMIX HMR BEGIN
if (!window.$RefreshReg$ || !window.$RefreshSig$ || !window.$RefreshRuntime$) {
  console.warn('remix:hmr: React Fast Refresh only works when the Remix compiler is running in development mode.');
} else {
  var prevRefreshReg = window.$RefreshReg$;
  var prevRefreshSig = window.$RefreshSig$;
  window.$RefreshReg$ = (type, id) => {
    window.$RefreshRuntime$.register(type, "\"app/components/static/AuditTool/PageSpeedInsights/InlineLighthouse.tsx\"" + id);
  }
  window.$RefreshSig$ = window.$RefreshRuntime$.createSignatureFunctionForTransform;
}
import * as __hmr__ from "remix:hmr";
if (import.meta) {
  import.meta.hot = __hmr__.createHotContext(
  //@ts-expect-error
  "app/components/static/AuditTool/PageSpeedInsights/InlineLighthouse.tsx");
  import.meta.hot.lastModified = "1717182690460.632";
}
// REMIX HMR END

import { Fragment } from "react";
import ProgressCircle from "./ProgressCircle";
export default function InlineLighthouse({
  psi
}) {
  return <Fragment>
      <ProgressCircle value={psi.performance} caption="Performance" />
      <ProgressCircle value={psi.accessibility} caption="Accesibility" />
      <ProgressCircle value={psi.bestPractices} caption="Best Practices" />
      <ProgressCircle value={psi.seo} caption="SEO" />
    </Fragment>;
}
_c = InlineLighthouse;
var _c;
$RefreshReg$(_c, "InlineLighthouse");

window.$RefreshReg$ = prevRefreshReg;
window.$RefreshSig$ = prevRefreshSig;